import React from 'react';
import { Grid, Paper, Box } from '@mui/material';
import { MapSyncProvider } from './maps/map_syncro_analy.js';
import MapLeft from './maps/map_left_analy.js';
import MapRight from './maps/map_right_analy.js';
import MapCrossborder from './maps/map_crossborder_analy.js';
import LoginMapRight from '../login/login_mapRight.js';

/**
 * Container component for analytics maps
 * @param {Object} props - Component props
 * @returns {JSX.Element} AnalyticsMapContainer component
 */
const AnalyticsMapContainer = ({
  prettyModelName,
  issueTime,
  cqlSevere,
  cqlFecha,
  mapLeftLayer,
  weekNumber,
  selectedTime,
  isAuthenticatedUser,
  mapRightLayer,
  selectedModel,
  mapCrossborderLayer,
  crossIssueTime,
  crossSelectedTime,
  onLogin
}) => {
  return (
    <div className="map-container">
      <Grid container spacing={2} sx={{ pl: 1.75, pr: 1.75 }}>
        {/* Main forecast map - full width */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ padding: 0.25, mx: 45, position: 'relative' }}>
            <span className="span_performance">
              <strong>{prettyModelName}</strong> forecast. ISSUE TIME: <strong>{issueTime} UTC</strong>
            </span>
            <MapSyncProvider>
              <MapLeft
                cqlSevere={cqlSevere}
                cqlFecha={cqlFecha}
                mapLeftLayer={mapLeftLayer}
                weekNumber={weekNumber}
                issueTime={issueTime}
                selectedTime={selectedTime}
              />
            </MapSyncProvider>
          </Paper>
        </Grid>
        
        {/* Container for Ground Truth and Cross Border maps */}
        <Grid container item xs={12} spacing={1}>
          {/* Ground Truth Map */}
          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ padding: 0.25 }}>
              <Box>
                <span className="span_performance">
                  Ground truth for VALID TIME: <strong>{cqlFecha} UTC</strong>
                </span>
                <MapSyncProvider>
                  <MapRight
                    cqlSevere={cqlSevere}
                    cqlFecha={cqlFecha}
                    mapRightLayer={mapRightLayer}
                    weekNumber={weekNumber}
                    issueTime={issueTime}
                    selectedModel={selectedModel}
                    isInteractive={isAuthenticatedUser}
                  />
                </MapSyncProvider>
                
                {/* Login overlay when not authenticated */}
                {!isAuthenticatedUser && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 27,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      borderRadius: '10px',
                      backgroundColor: 'rgba(255, 255, 255, 0.72)',
                      zIndex: 0,
                      backdropFilter: 'blur(5px)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      overflow: 'hidden',
                    }}
                  >
                    <LoginMapRight onLogin={onLogin} />
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>
          
          {/* Cross Border Map */}
          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ padding: 0.25 }}>
              <span className="span_performance">
                <strong>CROSS-BORDER</strong> forecast. ISSUE TIME: <strong>{crossIssueTime} UTC</strong>
              </span>
              <MapSyncProvider>
                <MapCrossborder
                  cqlSevere={cqlSevere}
                  cqlFecha={cqlFecha}
                  mapCrossborderLayer={mapCrossborderLayer}
                  weekNumber={weekNumber}
                  issueTime={crossIssueTime}
                  selectedTime={crossSelectedTime}
                />
              </MapSyncProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default AnalyticsMapContainer;
